import { render, staticRenderFns } from "./gb-label-value-text.vue?vue&type=template&id=9af51d6c&"
import script from "./gb-label-value-text.vue?vue&type=script&lang=js&"
export * from "./gb-label-value-text.vue?vue&type=script&lang=js&"
import style0 from "./gb-label-value-text.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports